import { Component } from '@angular/core';

@Component({
    selector: 'cr-avid-warning-svg',
    templateUrl: './warning-svg.component.html',
    styleUrls: ['./warning-svg.component.scss'],
})
export class WarningSvgComponent {}
